/***
usage:
 let sorted = employees.sort(ascendingSorter(employee => employee.id));
 let sorted = employees.sort(descendingSorter(employee => employee.id));
***/
export function ascendingSorter(selectorFunc: Function) {
  var sortFunc = function(a: any, b: any) {
    var sA = selectorFunc(a);
    var sB = selectorFunc(b);
    if (sA < sB) {
      return -1;
    }
    if (sA > sB) {
      return 1;
    }
    return 0;
  };
  return sortFunc;
}
export function descendingSorter(selectorFunc: Function) {
  var sortFunc = function(a: any, b: any) {
    var sA = selectorFunc(a);
    var sB = selectorFunc(b);
    if (sA < sB) {
      return 1;
    }
    if (sA > sB) {
      return -1;
    }
    return 0;
  };
  return sortFunc;
}

